import { ChangeEvent, useRef, useState } from "react";
import BookPurchase from "./components/book-purchase";
import GeneralInformation from "./components/general-information";
import Popover from "@app/components/popover";
import { PopoverRef } from "@app/components/popover/popover.component";
import Radio from "@app/components/radio";
import { calculateDateTemp, initialStateStatistics } from "./helper";
import { StatisticsState } from "@app/types";
import CalendarIcon from "@app/icons/calendar";
import Button from "@app/components/button";
import BookInteractions from "./components/book-interactions";
import Input from "@app/components/input";
import BookRevenueRetail from "./components/book-revenue-retail";
import BookRevenueVip from "./components/book-revenue-vip";

const StatisticsManagement = () => {
  const popoverRef = useRef<PopoverRef>(null);

  const [state, _setState] = useState<StatisticsState>(initialStateStatistics);
  const setState = (data: Partial<StatisticsState> = {}) =>
    _setState((pre) => ({ ...pre, ...data }));

  const handleChangeRadioDate = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === "custom") {
      setState({
        startDateTemp: undefined,
        endDateTemp: undefined,
        filterDate: event.target.value,
      });
    } else {
      const { startDateTemp, endDateTemp } = calculateDateTemp(
        event.target.value,
        state.startDateTemp,
        state.endDateTemp
      );

      setState({
        startDateTemp,
        endDateTemp,
        filterDate: event.target.value,
      });
    }
  };

  const handleFilterDate = () => {
    setState({
      startDate: state.startDateTemp,
      endDate: state.endDateTemp,
    });
    popoverRef.current?.close();
  };

  return (
    <div className="py-6 px-12">
      <div className="flex flex-col gap-[24px]">
        {/* Filter */}

        <div className="flex justify-end">
          <Popover
            ref={popoverRef}
            content={
              <div className="w-[320px]">
                <div>By date</div>
                <div>
                  <div className="mt-4 flex gap-4">
                    <Radio
                      name="date"
                      label="This week"
                      value={"thisWeek"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "thisWeek"}
                    />
                    <Radio
                      name="date"
                      label="Last week"
                      value={"lastWeek"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "lastWeek"}
                    />
                  </div>
                  <div className="mt-4 flex gap-4">
                    <Radio
                      name="date"
                      label="This month"
                      value={"thisMonth"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "thisMonth"}
                    />
                    <Radio
                      name="date"
                      label="Last month"
                      value={"lastMonth"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "lastMonth"}
                    />
                  </div>
                  <div className="mt-4 flex gap-4">
                    <Radio
                      name="date"
                      label="This year"
                      value={"thisYear"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "thisYear"}
                    />
                    <Radio
                      name="date"
                      label="Last year"
                      value={"lastYear"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "lastYear"}
                    />
                  </div>
                  <div className="mt-4 flex gap-4">
                    <Radio
                      name="date"
                      label="Custom"
                      value={"custom"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "custom"}
                    />
                    <Radio
                      name="date"
                      label="All time"
                      value={"allTime"}
                      onChange={handleChangeRadioDate}
                      className="flex-1"
                      checked={state.filterDate === "allTime"}
                    />
                  </div>
                  {state.filterDate === "custom" && (
                    <div className="mt-4 flex gap-4 justify-between">
                      <div className="w-[48%]">
                        <Input
                          type="date"
                          placeholder="Start date"
                          height="[30px]"
                          onChange={(e) =>
                            _setState((state) => ({
                              ...state,
                              startDateTemp: e.target.value,
                            }))
                          }
                          value={state.startDateTemp}
                        />
                      </div>
                      <div className="w-[48%]">
                        <Input
                          type="date"
                          placeholder="End date"
                          height="[30px]"
                          onChange={(e) =>
                            _setState((state) => ({
                              ...state,
                              endDateTemp: e.target.value,
                            }))
                          }
                          value={state.endDateTemp}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-4 w-full">
                  <Button
                    label="Filter"
                    theme="primary"
                    containerClassName="w-full"
                    onClick={handleFilterDate}
                  />
                </div>
              </div>
            }
            placement="bottomLeft"
          >
            <div className="flex cursor-pointer items-center gap-2 rounded-lg border border-solid border-[#5570F1] bg-white px-2 py-1 text-[#5570F1]">
              <CalendarIcon />
              <div>Filter</div>
            </div>
          </Popover>
        </div>

        {/* Content */}
        <GeneralInformation filter={state} />
        <BookRevenueRetail filter={state} />
        <BookRevenueVip filter={state} />
        <BookPurchase filter={state} />
        <BookInteractions filter={state} />
      </div>
    </div>
  );
};

export default StatisticsManagement;
